import cn from "classnames";
import BookShow from "components/shared/book/show";
import ContactInfo from "components/shared/contactInfo";
import { getCustomNumberConfig } from "components/shared/form";
import InlineBtn from "components/shared/inlineBtn";
import { trackerRelationTypesEnum } from "helpers/enums";
import { serializeReq } from "helpers/form";
import { checkMechanic } from "helpers/mechanics";
import { dieselFuelTank } from "helpers/models";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import { truckNumber } from "helpers/validators";
import { prepareVehicleOwnershipData } from "helpers/vehicles/ownership";
import { FuelTanks } from "helpers/vehicles/partials";
import policy from "policies";
import React from "react";
import { Link } from "react-router-dom";
import { applyCarFuelCards } from "sources/books/fuelCards";
import { getByPhoneNumber } from "sources/books/mechanics";
import { attach } from "sources/books/trackers";
import { getByPhoneNumber as getColumnDispatcherByPhone } from "sources/columnDispatcher";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowTruck extends BookShow {
    getNumberConfig = (useCustomNumber) => {
        return getCustomNumberConfig({
            number: this.props.config.number,
            useCustomNumber,
            numberValidator: truckNumber,
        });
    };

    getValidationConfig = (state) => ({
        ...this.props.config,
        number: this.getNumberConfig(!!state.useCustomNumber),
    });

    get dropdActions() {
        const actions = [{ text: "Печать", action: this.actionPrint }];

        const { isTechSupport, isTruckingOrganizationAdmin, isIntegrationManager } = this.props.roles;
        if (isTechSupport || isTruckingOrganizationAdmin || isIntegrationManager) {
            actions.unshift({
                text: "История привязки логистов",
                action: () => this.props.history.push(paths.logistHistory(this.state.data.id)),
            });
        }
        if (this.props.canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }
        return actions;
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            if (!data.fuelTanks || data.fuelTanks.length === 0) {
                data.fuelTanks = [{ ...dieselFuelTank }];
            }
            data.useCustomNumber = !!truckNumber(data.number).length;
            this.setState({ data, initial: data, ...defParams });
        });
    };

    actionPrint = () => {
        const { modal, config, trackersList, profile } = this.props;
        return modal({
            name: "print",
            title: "Печать машины",
            CustomBody: Markup,
            trackersList,
            bodyData: {
                ...config,
                values: this.state.initial,
                data: this.state.initial,
                renderCheckbox: this.renderCheckbox,
                renderFuelTanks: this.renderFuelTanks,
                renderFuelCards: this.renderFuelCards,
                renderMechanic: this.renderMechanic,
                renderСolumnDispatcher: this.renderСolumnDispatcher,
                availableFeatureModules: profile.availableFeatureModules,
                organizationName: profile.organizationName,
                ownershipDisabled: true,
            },
        });
    };

    setValue = ({ value, name, option }) => {
        const { data, initial, selectedOptions } = this.state;
        const nextData = { ...data, [name]: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({
            data: nextData,
            shouldUpdate,
            selectedOptions: { ...selectedOptions, [name]: option },
            ...(isValid ? { isValid: true } : {}),
        });
    };

    setCustomNumberMode = ({ value }) => {
        const { data, initial, selectedOptions } = this.state;
        const number = value ? data.number : "";
        const nextData = { ...data, number, useCustomNumber: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({
            data: nextData,
            shouldUpdate,
            selectedOptions,
            ...(isValid ? { isValid: true } : {}),
        });
    };

    renderFuelTanks = () => {
        const { modal, config, canEditBooks, roles } = this.props;
        const props = {
            modal,
            canEditBooks,
            roles,
            config: config.fuelTanks,
            fuelTanks: this.state.data.fuelTanks || [],
            setValue: this.setValue,
        };

        return <FuelTanks {...props} />;
    };

    linkFuelCards = () => {
        this.props.modal({
            name: "linkFuelCards",
            title: "Привязка топливных карт к машине",
            windowMod: "wide",
            data: { carId: this.state.data.id },
            linkedCardIds: this.state.data.fuelCards.map((item) => item.id),
            linkCards: applyCarFuelCards,
            callback: () => this.getItem(this.props),
        });
    };

    renderMechanic = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.data.mechanic,
            setValue: this.setValue,
            config: this.props.config.mechanic,
            getContactInfo: getByPhoneNumber,
            fieldName: "mechanic",
        };
        return <ContactInfo {...props} />;
    };

    renderСolumnDispatcher = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.data.columnDispatcher,
            setValue: this.setValue,
            config: this.props.config.columnDispatcher,
            getContactInfo: getColumnDispatcherByPhone,
            fieldName: "columnDispatcher",
        };
        return <ContactInfo {...props} />;
    };

    renderFuelCards = () => {
        const { profile, roles, refuelingSettings } = this.props;
        if (!policy("user", { user: { profile, roles }, options: { refuelingSettings } }).isFuelLimitEnabled()) {
            return null;
        }
        return (
            <div className="row pb-3">
                <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                    Топливные карты
                </label>
                <div className="col-sm-8 col-md-9 pt-1">
                    {this.state.data.fuelCards.map((card) => (
                        <span key={card.id} className="mr-2 badge badge-pill badge-primary">
                            {card.number}
                        </span>
                    ))}
                    <div className="mt-2">
                        <InlineBtn value="Привязать топливные карты" action={this.linkFuelCards} cname="plus" />
                    </div>
                </div>
            </div>
        );
    };

    renderButton = () => {
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        const { isRoot, isTechSupport, isTruckingOrganizationAdmin, isIntegrationManager } = this.props.roles;
        return (
            <div className="panel__row panel__row--button mb-3">
                {(isRoot || isTechSupport || isTruckingOrganizationAdmin || isIntegrationManager) && (
                    <Link className="btn btn-sm btn-link" to={paths.logistHistory(this.state.data.id)}>
                        Информация о привязке логистов
                    </Link>
                )}
                <div className={cname} onClick={this.apply}>
                    Обновить
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config, profile, refuelingSettings, roles } = this.props;
        const canEditLogist = roles.isTruckingOrganizationAdmin || roles.isTruckingOrganizationHeadLogist;
        const props = {
            renderField: this.renderField,
            renderSelect: this.renderSelect,
            renderCheckbox: this.renderCheckbox,
            renderFuelTanks: this.renderFuelTanks,
            renderFuelCards: this.renderFuelCards,
            renderMechanic: this.renderMechanic,
            setCustomNumberMode: this.props.canEditBooks ? this.setCustomNumberMode : undefined,
            data: this.state.data,
            renderСolumnDispatcher: this.renderСolumnDispatcher,
            valueOption: this.valueOption,
            Button: this.renderButton,
            availableFeatureModules: profile.availableFeatureModules,
            refuelingSettings,
            organizationName: profile.organizationName,
            ownershipDisabled: !this.props.canEditBooks,
            setValue: this.setValue,
            logistId: { ...config.logistId, alwaysEnabled: canEditLogist },
            trackerId: { ...config.trackerId, alwaysEnabled: !roles.isTruckingOrganizationExtendedViewer },
        };
        return <Markup {...config} {...props} />;
    };

    apply = () => {
        const { source, match, config } = this.props;
        const { isLoading, shouldUpdate, data, initial } = this.state;
        const { id, trackerId } = data;
        const initialTrackerid = initial.trackerId;

        const attachCurrentTracker = (id, trackerId) => {
            if (trackerId) {
                return this.attachTracker({ type: trackerRelationTypesEnum.Car, entityId: id, id: trackerId }).then(
                    () => this.getItem(this.props),
                );
            } else {
                this.setState({ isLoading: false, isValid: false });
                return Promise.all([]);
            }
        };

        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(data)) {
                this.setState({ isLoading: true, isValid: true });
                checkMechanic(data);

                let promise = null;
                if (initialTrackerid !== trackerId) {
                    if (!!initialTrackerid && !!trackerId) {
                        promise = this.attachTracker({
                            type: trackerRelationTypesEnum.Car,
                            entityId: null,
                            id: initialTrackerid,
                        }).then((res) => res && attachCurrentTracker(id, trackerId));
                    } else {
                        promise = this.attachTracker({
                            type: trackerRelationTypesEnum.Car,
                            entityId: trackerId ? id : null,
                            id: initialTrackerid || trackerId,
                        });
                    }
                } else {
                    promise = Promise.all([]);
                }

                const { useCustomNumber, ...requestData } = prepareVehicleOwnershipData(data);
                requestData.isLogistRemoval = true;

                return promise
                    .then(() => {
                        source
                            .apply(serializeReq({ id: match.params, ...requestData }, config))
                            .then((res) => res && this.update(this.props.mergeParams))
                            .then(() => this.setState({ isLoading: false, isValid: false }))
                            .catch(() => this.setState({ isLoading: false, isValid: false }));
                    })
                    .catch(() => this.setState({ isLoading: false, isValid: false }));
            }
            this.setState({ isValid: false });
        }
    };

    attachTracker = (params) => {
        return attach(params);
    };
}

const ConfiguredShow = (props) => {
    if (!policy("user", { user: { roles: props.roles } }).isTruckingOrganizationAdmin()) {
        config.transportColumnId.disabled = true;
    }
    return <ShowTruck {...props} config={config} initialState={initialState} />;
};

export default viewContainer(ConfiguredShow, "trucks");
